import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { rem } from 'design-system';
import Button from 'design-system/Button';
import Text from 'design-system/Text';
import ToastModal from 'design-system/ToastModal';
import { useTimeout } from 'hooks';
import { useMarginBottom } from 'hooks/useMarginBottom';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import useCreditReportDebtTracking from '../hooks/useCreditReportDebtTracking';
import { isWeb } from '../../../constants';
const TOAST_DURATION_MS = 3000;
let listener;
const CreditReportUntrackedToastHost = () => {
    const setTracked = useCreditReportDebtTracking();
    const [debts, setDebts] = useState([]);
    const isVisible = debts.length > 0;
    const { paddingHorizontal } = useAppFrameDimensions(isWeb);
    const marginBottom = useMarginBottom('marginBottom', undefined, styles.modal, isWeb && { marginLeft: paddingHorizontal });
    const modalStyle = useMemo(() => [marginBottom], [marginBottom]);
    useEffect(() => {
        listener = setDebts;
        return () => {
            if (listener === setDebts)
                listener = undefined;
        };
    }, []);
    const onHide = useCallback(() => setDebts([]), []);
    useTimeout(onHide, isVisible ? TOAST_DURATION_MS : undefined);
    const onUndo = useCallback(() => {
        setTracked(debts, true);
        setDebts([]);
    }, [debts, setTracked]);
    return (<ToastModal isVisible={isVisible} position="bottom" style={modalStyle} onCloseAction={onHide}>
      <View style={styles.text}>
        <Text TextThin-16 White>
          Debts excluded from net worth
        </Text>
      </View>
      <Button frosted square hug containerStyle={styles.containerStyle} title="Undo" onPress={onUndo}/>
    </ToastModal>);
};
const styles = StyleSheet.create({
    modal: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    containerStyle: {
        paddingHorizontal: rem(24),
    },
    text: {
        flex: 1,
        marginRight: rem(16),
    },
});
const CreditReportUntrackedToast = Object.assign(CreditReportUntrackedToastHost, {
    show: (debts) => listener?.(debts),
});
export default CreditReportUntrackedToast;
